// NetSuite locations (warehouse) and their bins (location_in_warehouse)
export const locationMenu = [
  {
    path: "/location",
    name: "location.parent",
    redirect: "/location/list",
    icon: "map-pin",
    meta: {
      title: "Location",
      parentMenu: true,
      ability: { action: "read", subject: "DeliveryOrder" },
    },
    children: [
      {
        path: "/location/list",
        name: "location.list",
        icon: "list",
        component: () => import("@/views/location/LocationList.vue"),
        meta: {
          title: "List",
          pageTitle: "Locations",
          ability: { action: "read", subject: "DeliveryOrder" },
        },
      },
      {
        path: "/location/zones",
        name: "location.zones",
        icon: "grid",
        component: () => import("@/views/location/LocationZones.vue"),
        meta: {
          title: "Zones",
          pageTitle: "Location Zones",
          ability: { action: "read", subject: "DeliveryOrder" },
        },
      },
    ],
  },
];
